const inspectionItems = [
  {
    title: 'ブレーキ',
    items: [
      {
        description: 'ブレーキ・ペダルの踏みしろが適当で、ブレーキのききが十分であること',
        fieldNumber: 265182310,
        required: true,
      },
      {
        description: 'ブレーキの液量が適当であること',
        fieldNumber: 1084496932,
        required: true,
      },
      {
        description: '空気圧力の上がり具合が不良でないこと',
        fieldNumber: 1320232679,
        required: true,
      },
      {
        description: 'ブレーキ・ペダルを踏み込んで放した場合にブレーキ・バルブからの排気音が正常であること',
        fieldNumber: 1051350402,
        required: true,
      },
      {
        description: '駐車ブレーキ・レバーの引きしろが適当であること',
        fieldNumber: 2102168673,
        required: true,
      },
    ],
  },
  {
    title: 'タイヤ',
    items: [
      {
        description: 'タイヤの空気圧が適当であること',
        fieldNumber: 192179184,
        required: true,
      },
      {
        description: '亀裂及び損傷がないこと',
        fieldNumber: 556853490,
        required: true,
      },
      {
        description: '異常な摩耗がないこと',
        fieldNumber: 140711689,
        required: true,
      },
      {
        description: 'ホイール・ナットの脱落・緩み、ホイールボルト折損等がないこと',
        fieldNumber: 237971034,
        required: true,
      },
      {
        description: '溝の深さが十分であること',
        fieldNumber: 2130918167,
        required: false,
      },
    ],
  },
  {
    title: 'バッテリー',
    items: [
      {
        description: '液量が適当であること',
        fieldNumber: 1958203792,
        required: false,
      },
    ],
  },
  {
    title: '原動機',
    items: [
      {
        description: '冷却水の量が適当であること',
        fieldNumber: 613650911,
        required: false,
      },
      {
        description: 'ファン・ベルトの張り具合が適当であり、かつ、ファン・ベルトに損傷がないこと',
        fieldNumber: 372295548,
        required: false,
      },
      {
        description: 'エンジン・オイルの量が適当であること',
        fieldNumber: 1476798105,
        required: false,
      },
      {
        description: '原動機のかかり具合が不良でなく、かつ、異音がないこと',
        fieldNumber: 151142719,
        required: false,
      },
      {
        description: '低速及び加速の状態が適当であること',
        fieldNumber: 1863265648,
        required: false,
      },
    ],
  },
  {
    title: '灯火装置及び方向指示器',
    items: [
      {
        description: '点灯又は点滅具合が不良でなく、かつ、汚れ及び損傷がないこと',
        fieldNumber: 984903326,
        required: true,
      },
    ],
  },
  {
    title: 'ウィンド・ウォッシャー及びワイパー',
    items: [
      {
        description: 'ウィンド・ウォッシャーの液量が適当であり、かつ、噴射状態が不良でないこと',
        fieldNumber: 1060920657,
        required: false,
      },
      {
        description: 'ワイパーの払拭状態が不良でないこと',
        fieldNumber: 1216630583,
        required: false,
      },
    ],
  },
  {
    title: 'エア・タンク',
    items: [
      {
        description: 'エア・タンクに疑水がないこと',
        fieldNumber: 116342892,
        required: true,
      },
    ],
  },
  {
    title: '運行において異状が認められた箇所',
    items: [
      {
        description: '当該個所に異状がないこと',
        fieldNumber: 2038461718,
        required: false,
      },
    ],
  },
  {
    title: 'その他自社で定めた点検内容',
    items: [
      {
        description: 'アドブルー',
        fieldNumber: 292641519,
        required: false,
      },
    ],
  },
]

module.exports = { inspectionItems }
